<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="550px"
    :close-on-click-modal="false"
  >
    <el-form size="small" label-position="right" label-width="80px">
      <el-row>
        <el-form-item label="房间号：">
          <el-input
            placeholder="请输入房间号"
            v-model="dialogInfo.roomNumber"
            show-word-limit
            :maxlength="50"
          />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    closeDia() {
      this.$emit("closeDia", false);
    },
    sureSubmit() {
      this.$emit("changeRoomNumber", this.dialogInfo.roomNumber);
    },
  },
};
</script>

<style>
</style>
